/**
 * @generated SignedSource<<79aca60a185187e13b132feae8221047>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskProblemCreationTypeEnum = "first" | "original" | "second" | "third" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TaskMigrationPairSyncDialog_task$data = {
  readonly aiFile: {
    readonly key: string;
    readonly objectUrl: string;
    readonly size: number;
  } | null;
  readonly id: string;
  readonly isMigrated: boolean | null;
  readonly migrationPair: {
    readonly id: string;
    readonly sequence: number;
  } | null;
  readonly problem: {
    readonly creationType: TaskProblemCreationTypeEnum | null;
    readonly problem: string | null;
    readonly solution: string | null;
  } | null;
  readonly " $fragmentType": "TaskMigrationPairSyncDialog_task";
};
export type TaskMigrationPairSyncDialog_task$key = {
  readonly " $data"?: TaskMigrationPairSyncDialog_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskMigrationPairSyncDialog_task">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskMigrationPairSyncDialog_task",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMigrated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "migrationPair",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sequence",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskProblem",
      "kind": "LinkedField",
      "name": "problem",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "problem",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "solution",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creationType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "aiFile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "size",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "objectUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};
})();

(node as any).hash = "551debf96bfc99c136862d88964cffb9";

export default node;
